import clsx from 'clsx';
import Link from 'next/link';
import React, { FunctionComponent, useCallback, useState } from 'react';
import Popup from 'reactjs-popup';
import { GiftIcon } from '../../Icons/GiftIcon';
import { InfoIcon } from '../../Icons/InfoIcon';
import styles from './SpecialOffer.module.scss';
import { SpecialOfferProps } from './SpecialOffer.type';

export const SpecialOffer: FunctionComponent<SpecialOfferProps> = ({
    title,
    tabs,
    additional,
    action,
    color,
    description,
}) => {
    const [activeTabIndex, setActiveTabIndex] = useState<number>(1);
    const handleSelectTab = useCallback(
        (tabIndex: number) => {
            if (activeTabIndex !== tabIndex) {
                setActiveTabIndex(tabIndex);
            }
        },
        [activeTabIndex]
    );
    return (
        <div className={styles.container}>
            <div className={styles.content}>
                {!!title && (
                    <div
                        className={clsx(styles.title, styles[color || action])}
                    >
                        {title}
                        {!!description && (
                            <Popup
                                trigger={
                                    <div>
                                        <InfoIcon fill="#363636" />
                                    </div>
                                }
                                on="hover"
                                position="bottom center"
                                mouseEnterDelay={300}
                            >
                                <div className={styles.markdown}>
                                    {description}
                                </div>
                            </Popup>
                        )}
                    </div>
                )}
                <div className={styles.tabChangerBar}>
                    {tabs?.map(
                        (tab: SpecialOfferProps['tabs'][0], idx: number) => {
                            return (
                                <button
                                    onClick={() => handleSelectTab(idx)}
                                    key={`${tab?.name}-${idx}`}
                                    className={clsx(
                                        styles.tabChangerButton,
                                        idx === activeTabIndex &&
                                            styles.activeButton
                                    )}
                                >
                                    {tab?.title}
                                </button>
                            );
                        }
                    )}
                </div>
                {tabs?.map((tab: SpecialOfferProps['tabs'][0], idx: number) => {
                    if (idx !== activeTabIndex) {
                        return null;
                    }
                    const conditions = tab?.conditions;
                    return (
                        !!conditions && (
                            <div
                                className={styles.conditions}
                                key={`${tab.name}-${idx}`}
                            >
                                {!!tab.price && (
                                    <div className={styles.prices}>
                                        <div className={styles.mainPrice}>
                                            {tab.price}
                                        </div>
                                        {!!tab.giftTexts && (
                                            <Popup
                                                trigger={
                                                    <div
                                                        className={
                                                            styles.giftPlus
                                                        }
                                                    >
                                                        <div>+</div>
                                                        <GiftIcon />
                                                    </div>
                                                }
                                                on="hover"
                                                position="bottom center"
                                                mouseEnterDelay={300}
                                            >
                                                <div
                                                    className={clsx(
                                                        styles.markdown,
                                                        styles.giftTexts
                                                    )}
                                                >
                                                    <h3>{tab.giftTexts[0]}</h3>
                                                    <p>{tab.giftTexts[1]}</p>
                                                    <a
                                                        href="https://estp.ru/upload/man/sample_report_counterparty.pdf"
                                                        download
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        {tab.giftTexts[2]}
                                                    </a>
                                                </div>
                                            </Popup>
                                        )}
                                        {!!tab.strikethroughPrice && (
                                            <div className={styles.striked}>
                                                {tab.strikethroughPrice}
                                            </div>
                                        )}
                                    </div>
                                )}
                                {!!tab.promotionText && (
                                    <div className={styles.promotionText}>
                                        {tab.promotionText}
                                    </div>
                                )}
                                {!!conditions.description?.length && (
                                    <div className={styles.description}>
                                        {conditions.description.map(
                                            (item, key) => (
                                                <p key={`description-${key}`}>
                                                    {item}
                                                </p>
                                            )
                                        )}
                                    </div>
                                )}
                                {!!conditions.withNds && (
                                    <div className={styles.nds}>
                                        {conditions?.ndsText}
                                    </div>
                                )}
                            </div>
                        )
                    );
                })}
                {!!additional && (
                    <div className={styles.additional}>
                        {additional.map((item, key) => (
                            <p key={key}>{item}</p>
                        ))}
                    </div>
                )}
                <Link href="/auth/login?backurl=https%3A%2F%2Festp.ru%2Fpersonal%2Flicense%2Fparticipants%2Flicenses%3FshowBuySubscriptionModal%3D1">
                    <a className={clsx(styles.action, styles[color || action])}>
                        {action === 'free' && 'Бесплатно'}
                        {action === 'buy' && 'Купить'}
                        {(action === 'connect' || action === 'orange') &&
                            'Подключить'}
                    </a>
                </Link>
            </div>
        </div>
    );
};
